/* Customer Reviews page: filters, sort, load more, read more and the photo viewer.
   No libraries, no network calls: every review is already in the page. */
(function () {
  var root = document.querySelector('[data-fcr]');
  if (!root) return;

  var list = root.querySelector('[data-fcr-list]');
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-fcr-review]'));
  if (!rows.length) return;

  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 10;
  var countEl = root.querySelector('[data-fcr-count]');
  var total = countEl ? parseInt(countEl.getAttribute('data-total'), 10) || rows.length : rows.length;
  var loaded = rows.length;
  var moreBtn = root.querySelector('[data-fcr-more]');
  var noneEl = root.querySelector('[data-fcr-none]');
  var cap = perPage;

  /* ---------- read more ---------- */
  rows.forEach(function (row) {
    var text = row.querySelector('[data-fcr-text]');
    if (!text) return;
    text.classList.add('fcr-text--clamp');
    // only offer the button when the text really is cut off
    requestAnimationFrame(function () {
      if (text.scrollHeight - text.clientHeight < 6) {
        text.classList.remove('fcr-text--clamp');
        return;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fcr-readmore';
      btn.textContent = 'Read more';
      btn.addEventListener('click', function () {
        var open = text.classList.toggle('fcr-text--clamp');
        btn.textContent = open ? 'Read more' : 'Read less';
      });
      text.insertAdjacentElement('afterend', btn);
    });
  });

  /* ---------- filters and sort ---------- */
  var ratingBoxes = Array.prototype.slice.call(root.querySelectorAll('[data-fcr-rating]'));
  var kindBoxes = Array.prototype.slice.call(root.querySelectorAll('[data-fcr-kind]'));
  var photoBox = root.querySelector('[data-fcr-photos]');
  var sortSelects = Array.prototype.slice.call(root.querySelectorAll('[data-fcr-sort], [data-fcr-sort-mobile]'));

  function checkedValues(boxes, attr) {
    return boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.getAttribute(attr); });
  }

  function matches(row) {
    var ratings = checkedValues(ratingBoxes, 'data-fcr-rating');
    if (ratings.length && ratings.indexOf(row.getAttribute('data-rating')) === -1) return false;
    var kinds = checkedValues(kindBoxes, 'data-fcr-kind');
    if (kinds.length && kinds.indexOf(row.getAttribute('data-kind')) === -1) return false;
    if (photoBox && photoBox.checked && parseInt(row.getAttribute('data-photos'), 10) < 1) return false;
    return true;
  }

  function filtersActive() {
    return checkedValues(ratingBoxes, 'data-fcr-rating').length > 0 ||
      checkedValues(kindBoxes, 'data-fcr-kind').length > 0 ||
      (photoBox && photoBox.checked);
  }

  function sortRows(mode) {
    var sorted = rows.slice().sort(function (a, b) {
      var da = parseInt(a.getAttribute('data-date'), 10) || 0;
      var db = parseInt(b.getAttribute('data-date'), 10) || 0;
      if (mode === 'rating') {
        var ra = parseInt(a.getAttribute('data-rating'), 10) || 0;
        var rb = parseInt(b.getAttribute('data-rating'), 10) || 0;
        if (ra !== rb) return rb - ra;
      } else if (mode === 'photos') {
        var pa = parseInt(a.getAttribute('data-photos'), 10) > 0 ? 1 : 0;
        var pb = parseInt(b.getAttribute('data-photos'), 10) > 0 ? 1 : 0;
        if (pa !== pb) return pb - pa;
      }
      return db - da;
    });
    sorted.forEach(function (row) { list.insertBefore(row, moreBtn ? moreBtn.parentNode : null); });
    rows = sorted;
  }

  function apply() {
    var shown = 0;
    var matching = 0;
    rows.forEach(function (row) {
      if (!matches(row)) { row.hidden = true; return; }
      matching++;
      if (matching <= cap) { row.hidden = false; shown++; } else { row.hidden = true; }
    });
    if (noneEl) noneEl.hidden = matching !== 0;
    if (moreBtn) moreBtn.hidden = shown >= matching;
    if (countEl) {
      countEl.textContent = filtersActive()
        ? 'Showing ' + shown + ' of ' + matching + ' matching'
        : 'Showing ' + shown + ' of ' + total;
    }
  }

  [].concat(ratingBoxes, kindBoxes, photoBox ? [photoBox] : []).forEach(function (box) {
    box.addEventListener('change', function () { cap = perPage; apply(); });
  });

  sortSelects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      sortSelects.forEach(function (other) { if (other !== sel) other.value = sel.value; });
      sortRows(sel.value);
      cap = perPage;
      apply();
    });
  });

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      cap += perPage;
      apply();
    });
  }

  /* ---------- phone filter panel ---------- */
  var panel = root.querySelector('[data-fcr-filters]');
  var openBtn = root.querySelector('[data-fcr-open-filters]');
  function setPanel(open) {
    if (!panel) return;
    if (open) { panel.setAttribute('data-open', ''); document.body.style.overflow = 'hidden'; }
    else { panel.removeAttribute('data-open'); document.body.style.overflow = ''; if (openBtn) openBtn.focus(); }
  }
  if (openBtn) openBtn.addEventListener('click', function () { setPanel(true); });
  root.querySelectorAll('[data-fcr-close-filters]').forEach(function (b) {
    b.addEventListener('click', function () { setPanel(false); });
  });

  apply();

  /* ---------- photo viewer ---------- */
  var dialog = document.querySelector('[data-fcr-viewer]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var photos = Array.prototype.slice.call(root.querySelectorAll('[data-fcr-photo]'));
  if (!photos.length) return;

  var imgEl = dialog.querySelector('[data-fcrv-img]');
  var prevBtn = dialog.querySelector('[data-fcrv-prev]');
  var nextBtn = dialog.querySelector('[data-fcrv-next]');
  var countBadge = dialog.querySelector('[data-fcrv-count]');
  var barTitle = dialog.querySelector('[data-fcrv-bartitle]');
  var index = 0;
  var opener = null;
  var pushedState = false;

  function fill(i) {
    index = (i + photos.length) % photos.length;
    var thumb = photos[index];
    var row = thumb.closest('[data-fcr-review]');
    imgEl.src = thumb.getAttribute('data-full') || '';
    var thumbImg = thumb.querySelector('img');
    imgEl.alt = thumbImg ? thumbImg.alt : 'Customer photo';

    var name = row.querySelector('[data-fcr-name]');
    var nameText = name ? name.textContent.trim() : '';
    dialog.querySelector('[data-fcrv-name]').textContent = nameText;
    dialog.querySelector('[data-fcrv-initial]').textContent = nameText.charAt(0).toUpperCase();
    dialog.querySelector('[data-fcrv-verified]').hidden = !row.querySelector('.fcr-verified');

    var stars = row.querySelector('.fcr-row__top .fcr-stars');
    var starSlot = dialog.querySelector('[data-fcrv-stars]');
    starSlot.innerHTML = stars ? stars.outerHTML : '';
    var date = row.querySelector('.fcr-date');
    dialog.querySelector('[data-fcrv-date]').textContent = date ? date.textContent.trim() : '';

    var text = row.querySelector('[data-fcr-text]');
    dialog.querySelector('[data-fcrv-text]').innerHTML = text ? text.innerHTML : '';

    var reply = row.querySelector('[data-fcr-reply]');
    var replySlot = dialog.querySelector('[data-fcrv-reply]');
    replySlot.hidden = !reply;
    replySlot.innerHTML = reply ? reply.innerHTML : '';

    var prodLink = row.querySelector('a.fcr-prod__name');
    var prodName = row.querySelector('.fcr-prod__name');
    var prodImg = row.querySelector('.fcr-prod__img img');
    var prodWrap = dialog.querySelector('[data-fcrv-prod]');
    dialog.querySelector('[data-fcrv-prodname]').textContent = prodName ? prodName.textContent.trim() : '';
    dialog.querySelector('[data-fcrv-prodimg]').innerHTML = prodImg ? '<img src="' + prodImg.src + '" alt="" width="60" height="60">' : '';
    if (prodLink) { prodWrap.href = prodLink.getAttribute('href'); prodWrap.hidden = false; }
    else { prodWrap.removeAttribute('href'); prodWrap.hidden = !prodName; }

    var many = photos.length > 1;
    prevBtn.disabled = !many;
    nextBtn.disabled = !many;
    countBadge.textContent = (index + 1) + ' / ' + photos.length;
    if (barTitle) barTitle.textContent = 'Customer photo · ' + (index + 1) + ' / ' + photos.length;
    dialog.setAttribute('aria-label', 'Customer photo from ' + nameText);
  }

  function open(i, fromEl) {
    opener = fromEl || null;
    fill(i);
    dialog.showModal();
    try { history.pushState({ fcrv: 1 }, ''); pushedState = true; } catch (e) { pushedState = false; }
  }

  // History is handled in one place, the dialog's own close event, so Esc, X, a tap outside
  // and the phone's Back button all end in the same state.
  function close() {
    if (dialog.open) dialog.close();
  }

  photos.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { open(i, thumb); });
  });

  prevBtn.addEventListener('click', function () { fill(index - 1); });
  nextBtn.addEventListener('click', function () { fill(index + 1); });
  dialog.querySelectorAll('[data-fcrv-close]').forEach(function (b) {
    b.addEventListener('click', function () { close(); });
  });

  // a click on the backdrop lands on the dialog itself
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close();
  });

  // Esc closes the dialog natively; keep history and focus in step
  dialog.addEventListener('close', function () {
    imgEl.src = '';
    if (opener) { opener.focus(); opener = null; }
    if (pushedState) { pushedState = false; try { history.back(); } catch (e) {} }
  });

  window.addEventListener('popstate', function () {
    if (dialog.open) { pushedState = false; dialog.close(); }
  });

  dialog.addEventListener('keydown', function (e) {
    if (photos.length < 2) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); fill(index - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); fill(index + 1); }
  });
})();
